import axios from "axios";
import { server } from "./backend-url";

export const deleteDeviceData = async (deviceId, options) => {
  const authToken = localStorage.getItem('AuthToken');
  const params = {
    location: options?.location ? "true" : null,
    insights: options?.insights ? "true" : null,
    ownership: options?.ownership ? "true" : null,
  };
  axios.defaults.headers.common = { Authorization: `${authToken}` };
  return await axios.delete(`${server}/api/dataClearing/${deviceId}`, { params });
}